import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { isEqual } from 'lodash';
import { IFiltersSliceState } from '../../DrilldownDashboardContainer/filters/filtersSlice';
import { RootState } from '../store';
import { getCommentCategories } from './commentCategoriesAPI';
import { buildHTMLFiltersSubtitle } from '../utils';

export interface ICommentCategoriesAPIResponse {
  values: [];
  segmentName: string;
  segmentCategory: string;
  question: string;
  avidLabel: string;
  surveyLabel: string;
  periodLabel: string;
  commentType: string;
}

export interface IChartData {
  y: number
  color: string
  mood: string
  parentid: string
  shortLabel: string
}

interface ICommentCategoriesState {
  isLoading: boolean;
  apiResponse: ICommentCategoriesAPIResponse;
  chartData: any;
  chartCategories: any;
  chartSubtitle: string;
}

const initialState: ICommentCategoriesState = {
  isLoading: false,
  apiResponse: {
    values: [],
    segmentName: "",
    segmentCategory: "",
    question: "",
    avidLabel: "",
    surveyLabel: "",
    periodLabel: "",
    commentType: "",
  },
  chartData: [],
  chartCategories: [],
  chartSubtitle: '',

}

export const loadCommentCategories = createAsyncThunk(
  'commentCategories/get',
  async (filters: IFiltersSliceState) => {
    return getCommentCategories(filters);

  }
);

export const commentCategoriesSlice = createSlice({
  name: 'commentCategories',
  initialState,
  reducers: {
    setHTMLSubtitle: (state: ICommentCategoriesState, action) => {
      const apiResponse = action.payload;
      if (!isEqual(state, apiResponse)) {
        state.apiResponse = apiResponse;
      }
      return state;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loadCommentCategories.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(loadCommentCategories.fulfilled, (state, action) => {
      const apiResponse = action.payload;
      if (apiResponse) {
        state.isLoading = false;
        state.apiResponse = apiResponse;

        const colorDictionary = {
          Compliment: '#0493FC',
          Suggestion: '#ffaa00',
          Neutral: '#e7e7e7'
        }
        state.chartData = apiResponse.values.map(({ label, mood, shortLabel, value }) => {
          return {
            y: parseInt(value),
            color: colorDictionary[mood],
            mood: mood,
            parentid: label,
            shortLabel: shortLabel
          }
        })

        state.chartCategories = apiResponse.values.map(({ label }) => {
          return (
            [label]
          )
        })

        const { avidLabel, surveyLabel, periodLabel, segmentName, segmentCategory, question } = apiResponse;
        state.chartSubtitle = avidLabel + ' ' + '|' + ' ' + surveyLabel + ' ' + '|' + ' ' + periodLabel;
        if (segmentName.length) {
          state.chartSubtitle += ' ' + '|' + ' ' + segmentCategory + ':' + segmentName
        };
        if (question.length) {
          state.chartSubtitle += ' ' + '|' + ' ' + question;
        }
      }


    });
  },
})

export const selectCommentCategories = (state: RootState) =>
  state.commentCategories;
export default commentCategoriesSlice.reducer;